import { ReactElement, useEffect, useRef } from 'react';
import { Dashboard } from '../../components/ClubeBaneficios/Dashboard';
import LoginForm from '../../components/ClubeBaneficios/LoginForm';
import { useAuth } from '../../contexts/AuthContext';
import RegisterForm from '../../components/ClubeBaneficios/RegisterForm';
import { useLocation, useNavigate } from 'react-router-dom';

export default function Cadastro(): ReactElement {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const redirectExecuted = useRef(false);

  // Redirecionamento para Clube Ben após login bem-sucedido
  useEffect(() => {
    if (user && !redirectExecuted.current) {
      redirectExecuted.current = true;

      setTimeout(() => {
        window.location.href = 'https://cuidado.clubeben.com.br/';
      }, 2000); // 2 segundos para ver os logs
    }
  }, [user]);

  const isRegister = location.pathname.endsWith('/registerForm');

  return (
    <div className="flex justify-center items-center bg-gray-50 px-4 p-4 sm:px-6">
      <div className="w-full max-w-4xl sm:max-w-6xl p-8 rounded-2xl shadow-lg sm:p-10">
        {isRegister ? (
          <RegisterForm onSwitchToLogin={() => navigate('/ClubeBeneficios')} />
        ) : (
          <LoginForm
            onSwitchToRegister={() => navigate('/ClubeBeneficios/registerForm')}
          />
        )}
      </div>
    </div>
  );
}
